import api from '../axios'

export async function doLogin(username, password) {
    try {
        const response = await api.post('/auth/login', { username, password });
        return response.data;
    } catch (error) {
        console.error('Login failed:', error);
        throw error;
    }
}

export async function requestPassword(username) {
    try {
        const response = await api.post('/auth/request-password', { username });
        return response.data;
    } catch (error) {
        console.error('Recovery password failed:', error);
        throw error;
    }
}

export async function resetPassword(password, token){
    try {
        const response = await api.post('/auth/change-password', { token, password });
        return response.data;
    } catch (error) {
        console.error('Reset password failed:', );
        throw new Error(error.response.data.message || 'Erro ao redefinir senha');
    }
}